"use client";

import { useLang } from "@/i18n/client";
import { useHydrated } from "@frend-digital/ui/hooks";
import { useMemo } from "react";

export const FormatDate = ({ children }: { children: string | Date }) => {
	const hydrated = useHydrated();
	const date = new Date(children);
	const language = useLang();
	const format = useMemo(() => {
		return formatter(language);
	}, [language]);

	if (!hydrated) return null;

	return <>{format.format(date)}</>;
};

const formatter = (locale: string) =>
	new Intl.DateTimeFormat(`${locale}`, {
		day: "2-digit",
		month: "long",
		year: "numeric",
	});
